<template>
  <div>
    <empty-state
      v-if="!restaurantIds"
      icon="mdi-silverware"
      :title="$t('select_restaurant')"
      :subtitle="$t('please_select_restaurant_to_view_data')"
    />

    <taken-table v-else :data="data" :loading="isLoading" :search-query="searchQuery" />
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";
import TakenTable from "@/components/guest/TakenTable.vue";
import reportService from "@/services/report";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "AdminTakenTab",
  mixins: [hasPrinting, hasExcel],
  components: {
    EmptyState,
    TakenTable,
  },
  props: {
    searchQuery: String,
    dateRange: Array,
    isActiveTab: Boolean,
    selectedRestaurants: Array,
    restaurantIds: String,
  },
  data() {
    return {
      data: [],
      isLoading: false,
    };
  },
  computed: {
    restaurantNames() {
      if (this.selectedRestaurants && this.selectedRestaurants.length > 0) {
        return this.selectedRestaurants.map((r) => r.name).join(", ");
      }
      return "Admin";
    },
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("company"), value: "menu", sortable: false },
        {
          text: this.$t("shift_one"),
          value: "shift_one",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("shift_two"),
          value: "shift_two",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("shift_three"),
          value: "shift_three",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("quantity"),
          value: "total",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  watch: {
    isPrinting(isPrinting) {
      if (!isPrinting || !this.isActiveTab || !this.data || this.data.length === 0) {
        return;
      }

      this.printTakenTable();
    },
    isExcelDownloading(isDownloading) {
      if (!isDownloading || !this.isActiveTab || !this.data || this.data.length === 0) {
        return;
      }

      this.exportTakenExcel();
    },
    dateRange: {
      handler() {
        if (this.restaurantIds) {
          this.loadData();
        }
      },
    },
    restaurantIds: {
      handler() {
        if (this.restaurantIds) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    async loadData() {
      if (!this.restaurantIds || !this.dateRange || this.dateRange.length !== 2) {
        return;
      }

      this.isLoading = true;
      try {
        const params = {
          date: this.dateRange[0],
          date2: this.dateRange[1],
          restaurants: this.restaurantIds,
        };

        const response = await reportService.getMultipleTotalGuest(params);
        this.data = response.data;
      } catch (error) {
        console.error("Error loading taken data:", error);
        this.data = [];
      } finally {
        this.isLoading = false;
      }
    },
    printTakenTable() {
      const tableItems = this.data.map((item, index) => ({
        num: index + 1,
        menu: item.menu || "",
        shift_one: item.shift_one || "0/0",
        shift_two: item.shift_two || "0/0",
        shift_three: item.shift_three || "0/0",
        total: item.total || "0/0",
      }));

      this.printDocument({
        pageTitle: this.$t("taken"),
        title: `${this.$t("taken")}`,
        subtitle: `${this.localeDate(this.dateRange[0])} - ${this.localeDate(
          this.dateRange[1]
        )}`,
        tables: [
          {
            headers: this.headers.map((h) => ({
              text: h.text,
              value: h.value,
              align: h.align,
            })),
            items: tableItems,
          },
        ],
      });
    },
    exportTakenExcel() {
      const tableItems = this.data.map((item, index) => ({
        num: index + 1,
        menu: item.menu || "",
        shift_one: item.shift_one || "0/0",
        shift_two: item.shift_two || "0/0",
        shift_three: item.shift_three || "0/0",
        total: item.total || "0/0",
      }));

      this.downloadExcel({
        fileName: `${
          this.selectedRestaurants.length > 0 ? "selected_restaurants" : "admin"
        }_preuzeto_${this.dateRange[0]}_${this.dateRange[1]}.xlsx`,
        sheets: [
          {
            name: this.$t("taken"),
            title: `${this.$t("taken")}`,
            subtitle: `${this.$t("date")}: ${this.dateRange[0]} - ${this.dateRange[1]}`,
            headers: this.headers.map((h) => ({
              text: h.text,
              value: h.value,
              align: h.align,
            })),
            items: tableItems,
          },
        ],
      });
    },
  },
};
</script>
